<template>
  <div class="list-card" :class="{ selected: boxValue }">
    <div v-if="header" class="header-card">
      <h5 class="cursor-pointer" @click="handleClick">{{ title }}</h5>
    </div>
    <div class="content-card cursor-pointer" @click="handleClick">
      <slot />
    </div>
    <div v-if="footer" class="footer-card cursor-pointer">
      <div v-if="priority" class="priority" @click="handleClick">
        <div class="priority-circle" :class="'bg-' + priorityObject.color"></div>
        Priorité {{ priorityObject.text }}
      </div>
      <div v-if="add || showUsers" class="assigned-users" @click="handleUserClick">
        <h-e-multiple-profile-default
          v-if="!v2"
          :key="keyUsers"
          :add="add"
          size="sm"
          :users="users"
          :assigned-users="assignedUsers"
        >
        </h-e-multiple-profile-default>
        <h-e-multiple-profile-default-v2
          v-else
          :assigned-users-object="assignedUsersObject"
          size="sm"
          :add="add"
        ></h-e-multiple-profile-default-v2>
      </div>
    </div>
    <div class="footer-label">
      <slot name="footer-label"></slot>
    </div>
    <div v-if="indicator" class="indicator">
      <h-b-action :positive="positive" :text="text" :color="color"></h-b-action>
    </div>
    <div v-if="action" class="action">
      <slot name="action"></slot>
      <b-checkbox v-if="select" v-model="boxValue" :value="true" :unchecked-value="false"></b-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card',

  props: {
    priority: {
      type: String,
      default: '',
    },
    assignedUsers: {
      type: Array,
      default() {
        return []
      },
    },
    title: {
      type: String,
      default: '',
    },
    value: Boolean,
    users: {
      type: Array,
      default() {
        return []
      },
    },
    id: {
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: '',
    },
    showUsers: {
      type: Boolean,
      default: false,
    },
    select: {
      type: Boolean,
      default: true,
    },
    footer: {
      type: Boolean,
      default: true,
    },
    indicator: {
      type: Boolean,
      default: false,
    },
    positive: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'success',
    },
    v2: {
      type: Boolean,
      default: false,
    },
    assignedUsersObject: {
      type: Array,
      default: () => [],
    },
    add: {
      type: Boolean,
      default: true,
    },
    selectable: {
      type: Boolean,
      default: true,
    },
    action: {
      type: Boolean,
      default: true,
    },
    header: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      priorityObject: {
        text: null,
        color: null,
      },
      boxValue: this.value,
      keyUsers: 0,
    }
  },

  watch: {
    boxValue() {
      this.handleBoxValue()
    },

    users: {
      deep: true,
      handler() {
        this.updateUsers()
      },
    },

    priority() {
      this.formatPriority()
    },

    value() {
      this.boxValue = this.value
    },
  },

  mounted() {
    this.formatPriority()
  },

  methods: {
    formatPriority() {
      if (this.priority === 'weak') {
        this.priorityObject.text = 'Faible'
        this.priorityObject.color = 'success'
      } else if (this.priority === 'medium') {
        this.priorityObject.text = 'Moyenne'
        this.priorityObject.color = 'info'
      } else if (this.priority === 'strong') {
        this.priorityObject.text = 'Forte'
        this.priorityObject.color = 'danger'
      }
    },

    handleBoxValue() {
      this.$emit('input', this.boxValue)
      this.$emit('change', { id: this.id, value: this.boxValue, state: this.state })
    },

    handleClick() {
      this.$emit('click')
    },

    handleUserClick() {
      this.$emit('clickUsers')
    },

    updateUsers() {
      this.keyUsers += 1
    },
  },
}
</script>

<style scoped></style>
